<template>
  <div class="experience">
    <h3>Experience</h3>
    <div class="content">
      <div class="exp-item">
        <div class="job">
          <a class="company" href="http://www.whalerockindustries.com/" target="_blank">Whalerock Digital Media LLC.</a>
          <div class="duration">Jul '16 &mdash; Current</div>
        </div>
        <div class="title">Software Engineer, Fullstack</div>
      </div>
      <div class="exp-item">
        <div class="job">
          <a class="company" href="https://www.leafgroup.com/" target="_blank">Demand Media Inc.</a>
          <div class="duration">Sep '15 &mdash; Jun '16</div>
        </div>
        <div class="title">Sr. Software Engineer</div>
      </div>
      <div class="exp-item">
        <div class="job">
          <a class="company" href="https://www.leafgroup.com/" target="_blank">Demand Media Inc.</a>
          <div class="duration">Jun &mdash; Sep '15</div>
        </div>
        <div class="title">Software Engineer</div>
      </div>
      <div class="exp-item">
        <div class="job">
          <a class="company" href="https://www.leafgroup.com/" target="_blank">Demand Media Inc.</a>
          <div class="duration">Feb &mdash; May '14</div>
        </div>
        <div class="title">Software Engineer Intern</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'experience',
  };
</script>


// WEBPACK FOOTER //
// Experience.vue?6e288a8d